import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL

export const customAuthAxios = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
}
});

customAuthAxios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    const token = localStorage.getItem('localJWT');
    // console.log("LocalStorageから取得したトークン:", token); // 確認用
    // console.log(apiUrl); // 確認用
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});


customAuthAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log(error);
        switch (error.response?.status) {
            case 400:
                throw error;
            case 401: // Unauthorized
                window.location.href = '/login';
                console.log("AuthorizeError");
                break;
            case 403: // Forbidden
                alert("権限がありません。");
                break;
            case 404: // Not Found
                throw error;
            case 500: // Internal Server Error
                window.location.href = '/server-error';
                throw error;
            default:
                console.log('予期しないエラーが発生しました');
                alert('予期しないエラーが発生しました');
                break;
        }
    }
);